export const jobEntryKeys = {
    all: ['job-entry'] as const,
    lastRates: (customerId: string) => [...jobEntryKeys.all, 'last-rates', customerId] as const,
}
